import { Reveal } from "./Reveal";
import { SITE } from "@/lib/site";

const stats = [
  { value: "2016", label: "Founded" },
  { value: "$480M+", label: "Assets Advised" },
  { value: "320+", label: "Households Served" },
  { value: "97%", label: "Client Retention" },
];

export const About = () => (
  <section id="about" className="relative py-24 md:py-32" data-testid="about-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-8 grid lg:grid-cols-12 gap-14 items-center">
      <Reveal className="lg:col-span-6 order-2 lg:order-1">
        <div className="relative">
          <img
            src={SITE.images.about}
            alt="The Sagos advisory team"
            className="rounded-3xl border border-border w-full h-[440px] object-cover shadow-[0_30px_70px_-40px_rgba(11,42,91,0.5)]"
          />
          <div className="absolute -bottom-8 right-6 bg-white border border-border rounded-2xl px-7 py-6 shadow-xl max-w-[240px]">
            <p className="font-serif text-2xl text-slate-900 leading-snug">Independent & fiduciary</p>
            <p className="text-sm text-slate-500 mt-2">No products to sell. Only advice that serves you.</p>
          </div>
        </div>
      </Reveal>

      <div className="lg:col-span-6 order-1 lg:order-2">
        <Reveal>
          <p className="overline text-primary mb-4">Our Story</p>
          <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-slate-900 leading-tight">
            A firm built on discipline, discretion and trust.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 text-lg text-slate-600 leading-relaxed">
            Founded in {SITE.founded} in the heart of Grand Rapids, Sagos was created for
            people who expect more from their financial partners. We combine institutional-grade
            analysis with the attentiveness of a family office.
          </p>
          <p className="mt-4 text-slate-600 leading-relaxed">
            Every engagement begins with listening. We map your ambitions, pressure-test the plan,
            and steward it through every market cycle — quietly, consistently, and always in your interest.
          </p>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-px bg-border rounded-2xl overflow-hidden border border-border">
            {stats.map((s) => (
              <div key={s.label} className="bg-white p-5">
                <p className="font-serif text-3xl text-primary">{s.value}</p>
                <p className="overline text-slate-400 mt-2">{s.label}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
